import { Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild } from "@angular/core";

@Component({
    selector: "deloitteai-icon-loading",
    templateUrl: "./loading-icon.html"
})
export class DeloitteAiLoadingIconComponent implements OnInit, OnDestroy {

    protected isDestroyed = false;

    /**
     * the svg element which should be animated
     */
    @ViewChild("icon", { read: ElementRef, static: true})
    private icon: ElementRef<SVGElement>;

    /**
     * circles we want to animate
     */
    private circles: NodeListOf<SVGCircleElement>;

    private start: number = null;

    private animationFrame: number;

    public constructor(
        private zone: NgZone
    ) {}

    ngOnInit(): void {
        this.circles = this.icon.nativeElement.querySelectorAll(`circle`);

        this.zone.runOutsideAngular(() => {
            this.animationFrame = window.requestAnimationFrame((timestamp: number) => this.animate(timestamp));
        });
    }

    ngOnDestroy(): void {
        window.cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
        this.circles = null;
        this.icon = null;
    }

    private animate(timestamp: number): any {

        if (!this.start) {
            this.start = timestamp;
        }

        const n = timestamp - this.start;
        const e = Math.min(n / 40, 23);
        const a = [];

        if (930 < n) {
            this.start = this.start + 930;
        }

        for (let o = 0; 3 > o; o++) {
            a[o] = Math.max(e - 2 * o, 0);
            if (a[o] > 8) {
                a[o] = 16 - a[o];
            }
            a[o] = Math.max(a[o], 0);
            this.circles[o].setAttribute("transform", "translate(0 " + a[o] + ")");
        }

        this.animationFrame = window.requestAnimationFrame(this.animate.bind(this));
    }
}
